import React from 'react';
import { Box, Text, Title, VerticalBox } from '../../../../components';
import { SectionContainer } from '../../styles';
import { AboutUsDescription } from '../../../../services/about-us/fetchAboutUsPageContent';
import { COLORS, device, FONTS } from '../../../../constants';
import styled from 'styled-components';
import { DescriptionCardItem } from './DescriptionCardItem';
import { MotionText } from '../../../../components/Motion';

interface DescriptionProps {
  description: AboutUsDescription;
}

const Description = ({ description }: DescriptionProps) => {
  return (
    <SectionContainer $color={COLORS.GRAY_BG_COLOR}>
      <VerticalBox>
        <Box>
          <DescriptionWrapper>
            <TextWrapper>
              <Title
                color={COLORS.SECTION_TITLE}
                title={description.Title}
                size={36}
                lineHeight={54}
                weight={400}
              />
              <Text
                text={description.Subtitle}
                fontFamily={FONTS.SUBTITLE}
                size={22}
                lineHeight={33}
                color={COLORS.SECTION_TEXT}
              />
            </TextWrapper>
            <DescriptionCardsContainer>
              {description.cards.map(item => (
                <DescriptionCardItem key={item.id} descriptionCardItem={item} />
              ))}
            </DescriptionCardsContainer>
          </DescriptionWrapper>
        </Box>
      </VerticalBox>
    </SectionContainer>
  );
};

const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
  > div > h4 {
    max-width: 63%;
  }
  @media screen and ${device.md} {
    gap: 20px;
    h4 {
      font-size: 17px;
      line-height: 26px;
    }
  }
  @media screen and ${device.sm} {
    > div > h4 {
      font-size: 15px;
      line-height: 25px;
      max-width: none;
    }
  }
`;

const TextWrapper = styled(MotionText)`
  display: flex;
  flex-direction: column;
  gap: 60px;

  @media screen and ${device.md} {
    gap: 20px;
  }
`;

const DescriptionCardsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 60px;
  @media screen and ${device.md} {
    gap: 20px;
  }
  @media screen and ${device.sm} {
    flex-direction: column;
    align-items: center;
  }
`;

export { Description };
